import React from 'react';
import { Stack } from 'expo-router';

// Mesmo padrão de app/(auth)/_layout.tsx: stack simples sem header nativo
// (cada tela cuida do próprio título/voltar), agora usado para permitir uma
// segunda tela ("excluir-conta") dentro da aba Perfil.
export default function PerfilLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
